import Api from "../../axios";

export const postAddAttendanceOfEmployee = async (data) => {
  return await Api.post("/add_attendance", {...data});
};
